import { DatePicker } from "antd";

const RangePickerField = ({
  picker,
  format,
  disabledDate,
  onChange,
  className,
}) => {
  const { RangePicker } = DatePicker;
  return (
    <RangePicker
      picker={picker}
      format={format}
      disabledDate={disabledDate}
      onChange={onChange}
      className={className}
    />
  );
};

export default RangePickerField;
